import { render, staticRenderFns } from "./VenueSidebar.vue?vue&type=template&id=5ba822b8&"
import script from "./VenueSidebar.vue?vue&type=script&lang=js&"
export * from "./VenueSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports